import { ChildModel, ModelBase } from 'store/model-base';
import { AccountDetail } from './account-detail';
import { Line } from './line';

export class LineTransfer extends ModelBase {
    public static storeName: string = 'lineTransfer';

    public transferSessionId: string;
    public creationDate: string;
    public sourceAccount: AccountDetail;
    public targetAccount: AccountDetail;
    public originatingAccount: string;
    public lines: Line[];
    public transferPinExpires: string;
    public status: string;

    public static create<T extends ModelBase>(data: ApiResponse): T {
        return super.create<T>(data);
    }
    protected static get hasMany(): ChildModel[] {
        return [{
            attrName: 'lines',
            model: Line
        }];
    }
}
